import { Directive, Input, ElementRef, OnInit, OnChanges, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { TranslateService } from './translate.service';

@Directive({
  selector: '[uexTranslate]',
})
export class TranslateDirective implements OnInit, OnChanges, OnDestroy {
  @Input('uexTranslate') private _path: string;

  constructor(
    private _translateService: TranslateService,
    private _elementRef: ElementRef
  ) { }

  private _update_subscription: Subscription;

  public ngOnInit() {
    this._update_subscription = this._translateService.onUpdate.subscribe(() => this._update());
  }

  public ngOnChanges() {
    this._update();
  }

  public ngOnDestroy() {
    if (this._update_subscription) { this._update_subscription.unsubscribe(); }
  }

  private _update() {
    if (this._path) { this._elementRef.nativeElement.textContent = this._translateService.get(this._path); }
  }
}
